<section
    [class.card]="isStandalone"
    [class.sb-highlight-content]="(viewportSize$ | async) !== 'xs' && showOptions"
    *ngIf="chartView$ | async as view"
>
    <header [class.card-header]="isStandalone" class="align-items-center mt-n2">
        <ng-container *ngIf="isStandalone">
            <h3 class="mb-0" *ngIf="!this.restrictDashboardChartView; else fixedHeading">
                View
                <sb-generic-type-select
                    class="d-inline-block my-n3"
                    [formControl]="viewCtrl"
                    appearance="none"
                    [valueKey]="false"
                    [options]="viewOptions"
                ></sb-generic-type-select>
            </h3>
            <ng-template #fixedHeading>
                <h3 class="mb-0 mt-3">
                    {{
                        restrictDashboardChartView === 'marketValue'
                            ? 'Market value over time'
                            : 'Performance over time'
                    }}
                </h3>
            </ng-template>
        </ng-container>
        <div class="d-flex align-items-center sb-chart-actions justify-content-end">
            <!-- <sb-slide-toggle
                @fadeInOut
                *ngIf="view.value === 'marketValue'"
                [formControl]="chartAxisCtrl"
                [options]="chartAxisOptions$ | async"
                [disabled]="isLoading$ | async"
                class="d-block pe-3"
            ></sb-slide-toggle>-->
            <div class="sb-chart-settings m-n3">
                <!--<a
                    type="button"
                    class="btn btn-link text-primary me-n2"
                    [routerLink]="['', { outlets: { dialog: ['stress-test-scenario'] } }]"
                    queryParamsHandling="merge"
                >
                    <tabler-icon name="gauge"></tabler-icon>
                </a>
                <a
                    type="button"
                    class="btn btn-link text-primary me-n2"
                    [routerLink]="[
                        '',
                        { outlets: { dialog: ['portfolio', 'optimization'] } }
                    ]"
                    queryParamsHandling="merge"
                >
                    <tabler-icon name="chart-infographic"></tabler-icon>
                </a>-->
                <button
                    type="button"
                    class="btn btn-link text-primary"
                    (click)="toggleShowOptions()"
                >
                    <tabler-icon name="adjustments-horizontal"></tabler-icon>
                    <sb-notification-badge
                        *ngIf="
                            (chartView$ | async).value === 'marketValue' &&
                            (filterInstrumentTypeCtrl.value
                                | sbFilterCount
                                    : (availableInstrumentTypes$ | async)
                                    : (isLoading$ | async)) +
                                (issuersCtrl.value
                                    | sbFilterCount
                                        : (availableIssuers$ | async)
                                        : (isLoading$ | async)) as numberOfFilters
                        "
                        [@fadeInOut]
                        [tooltip]="
                            numberOfFilters === 1
                                ? 'A filter has been applied for the data.'
                                : numberOfFilters +
                                  ' filters have been applied for the data.'
                        "
                        [numberOfNotifications]="numberOfFilters"
                        [iconBadge]="true"
                    ></sb-notification-badge>
                    <sb-notification-badge
                        *ngIf="
                            (chartView$ | async).value === 'performance' &&
                            (issuersCtrl.value
                                | sbFilterCount
                                    : (availableIssuers$ | async)
                                    : (isLoading$ | async)) as numberOfFilters
                        "
                        [@fadeInOut]
                        [tooltip]="
                            numberOfFilters === 1
                                ? 'A filter has been applied for the data.'
                                : numberOfFilters +
                                  ' filters have been applied for the data.'
                        "
                        [numberOfNotifications]="numberOfFilters"
                        [iconBadge]="true"
                    ></sb-notification-badge>
                </button>
            </div>
        </div>
    </header>
    <div [class.card-body]="isStandalone">
        <div @fadeInOut *ngIf="view.value === 'performance'">
            <sb-key-metrics
                [metrics]="performanceKeyMetrics$ | async"
                [forceHorizontal]="true"
            ></sb-key-metrics>
            <div class="overflow-hidden">
                <sb-performance-chart
                    #chartRef
                    [series]="performanceChartData$ | async"
                    context="dashboard-performance-chart"
                    [customOptions]="performanceChartOptions"
                    [loading]="isLoading$ | async"
                    (loadingChange)="onLoadingStateChange($event)"
                    [benchmarks]="activeBenchmarks$ | async"
                    (benchmarksChange)="onBenchmarksChange($event)"
                    [fitHeightToParent]="fitHeightToParent"
                ></sb-performance-chart>
            </div>
            <ng-container *ngIf="{ isLoading: isLoading$ | async } as loadingState">
                <dl
                    class="sb-period-select d-flex justify-content-between my-0 mx-n2 overflow-x-auto-hover"
                    *ngIf="activePeriod$ | async as selectedPeriod"
                >
                    <ng-container
                        *ngFor="
                            let period of performanceSummary$
                                | async
                                | keyvalue : periodOrderFn;
                            trackBy: trackByFn
                        "
                    >
                        <div
                            class="d-flex flex-column text-center px-2"
                            *ngIf="!period.value.hide"
                            [class.active]="period.value.name === selectedPeriod.name"
                            [class.disabled]="loadingState.isLoading"
                            (click)="
                                loadingState.isLoading ? null : updatePeriod(period.value)
                            "
                        >
                            <dt>{{ period.value.name }}</dt>
                            <!--<dd
                    class="value-color"
                    [class.value-positive]="period.absolute > 0"
                    [class.value-negative]="period.absolute < 0"
                >
                    {{ period.absolute | formatCurrency$ | async }}
                </dd>-->
                            <dd
                                class="value-color"
                                [class.value-positive]="period.value.relative > 0"
                                [class.value-negative]="period.value.relative < 0"
                            >
                                <span
                                    *ngIf="
                                        period.value.relative < 1000 &&
                                            period.value.relative > -1000;
                                        else superHighFigure
                                    "
                                >
                                    {{
                                        period.value.relative
                                            | formattedPercent$ : '0' : '0.0-2'
                                            | async
                                    }}
                                </span>
                                <ng-template #superHighFigure>
                                    <span
                                        [matTooltip]="
                                            period.value.relative
                                                | formattedPercent$ : '0' : '0.0-2'
                                                | async
                                        "
                                    >
                                        ∞
                                    </span>
                                </ng-template>
                            </dd>
                            <!--<dd>{{ period.volatility | formattedPercent$ | async }}</dd>-->
                        </div>
                    </ng-container>
                </dl>
            </ng-container>
        </div>
        <div @fadeInOut *ngIf="view.value === 'marketValue'">
            <sb-key-metrics
                [metrics]="marketValueKeyMetrics$ | async"
                forceHorizontal="true"
            ></sb-key-metrics>
            <div class="overflow-hidden">
                <sb-performance-chart
                    #chartRef
                    [series]="marketValueData$ | async"
                    context="dashboard-market-value-chart"
                    [customOptions]="marketValueChartOptions$ | async"
                    [loading]="isLoading$ | async"
                    (loadingChange)="onLoadingStateChange($event)"
                    [axisType]="chartAxis$ | async"
                    [events]="events$ | async"
                    [fitHeightToParent]="fitHeightToParent"
                ></sb-performance-chart>
            </div>
            <ng-container *ngIf="{ isLoading: isLoading$ | async } as loadingState">
                <div class="overflow-x-auto invisible-scroll">
                    <dl
                        class="sb-period-select d-flex justify-content-between my-0 mx-n2 overflow-x-auto-hover"
                        *ngIf="activePeriod$ | async as selectedPeriod"
                    >
                        <ng-container
                            *ngFor="
                                let period of periodSummary$
                                    | async
                                    | keyvalue : periodOrderFn;
                                trackBy: trackByFn
                            "
                        >
                            <div
                                class="d-flex flex-column text-center px-2"
                                *ngIf="!period.value.hide"
                                [class.active]="period.value.name === selectedPeriod.name"
                                [class.disabled]="loadingState.isLoading"
                                (click)="
                                    loadingState.isLoading
                                        ? null
                                        : updatePeriod(period.value)
                                "
                            >
                                <dt>{{ period.value.name }}</dt>
                                <!--<dd
                    class="value-color"
                    [class.value-positive]="period.absolute > 0"
                    [class.value-negative]="period.absolute < 0"
                >
                    {{ period.absolute | formatCurrency$ | async }}
                </dd>-->
                                <dd
                                    class="value-color"
                                    [class.value-positive]="
                                        period.value.relativeChange > 0
                                    "
                                    [class.value-negative]="
                                        period.value.relativeChange < 0
                                    "
                                >
                                    <span
                                        *ngIf="
                                            period.value.relativeChange < 1000 &&
                                                period.value.relativeChange > -1000;
                                            else superHighFigure
                                        "
                                    >
                                        {{
                                            period.value.relativeChange
                                                | formattedPercent$ : '0' : '0.0-2'
                                                | async
                                        }}
                                    </span>
                                    <ng-template #superHighFigure>
                                        <span
                                            [matTooltip]="
                                                period.value.relativeChange
                                                    | formattedPercent$ : '0' : '0.0-2'
                                                    | async
                                            "
                                        >
                                            ∞
                                        </span>
                                    </ng-template>
                                </dd>
                                <!--<dd>{{ period.volatility | formattedPercent$ | async }}</dd>-->
                            </div>
                        </ng-container>
                    </dl>
                </div>
            </ng-container>
        </div>
    </div>
</section>
<div
    class="sb-modal-grid"
    [class.sb-modal-aside-right]="(viewportSize$ | async) !== 'xs'"
    *ngIf="showOptions"
    [@fadeInOutModal]
>
    <section
        role="dialog"
        aria-modal="true"
        aria-label="Add or update data"
        class="sb-modal-grid-container sb-modal-xs"
        *ngIf="chartView$ | async as view"
    >
        <header class="sb-modal-grid-header">
            <h2 class="mb-0">Settings</h2>
        </header>
        <main class="sb-modal-grid-body">
            <div
                class="row gy-3"
                *ngIf="showOptions && view.value === 'performance'"
                @fadeInOut
            >
                <div class="col-12 sb-tag-filters pb-3">
                    <h4 class="mb-2">Benchmarks</h4>
                    <sb-badges
                        size="sm"
                        allowActive="multiple"
                        variant="primary"
                        [wrap]="true"
                        [badges]="availableBenchmarks$ | async"
                        (badgesChange)="toggleBenchmarks($event)"
                    ></sb-badges>
                </div>
                <sb-pro-tip
                    id="sb-dashboard-performance"
                    heading="Filter improvement"
                    *ngIf="disableFilters"
                >
                    Filtering by issuer or legal entity is currently disabled as we're
                    working on improving the feature. Stay tuned!
                </sb-pro-tip>
                <div class="col-12 sb-tag-filters pb-3" [class.disabled]="disableFilters">
                    <h4 class="mb-2">Filter by issuer</h4>
                    <sb-badges
                        size="sm"
                        allowActive="multiple-not-empty"
                        variant="primary"
                        [wrap]="true"
                        [badges]="availableIssuers$ | async"
                        (badgesChange)="filterIssuers($event)"
                    ></sb-badges>
                </div>
                <!--<div class="col-12 sb-tag-filters pb-3" [class.disabled]="disableFilters">
                    <h4 class="mb-2">Filter by legal entity</h4>
                    <sb-badges
                        size="sm"
                        allowActive="multiple"
                        variant="primary"
                        wrap="true"
                        [badges]="availableLegalEntities$ | async"
                        (badgesChange)="filterLegalEntities($event)"
                    ></sb-badges>
                </div>-->
            </div>
            <div
                class="row gy-3"
                *ngIf="showOptions && view.value === 'marketValue'"
                @fadeInOut
            >
                <!-- only show filter if more than one option exists -->
                <!--
                <ng-container
                    *ngIf="availableLegalEntities$ | async as availableLegalEntities"
                >
                    <div
                        class="col-12 sb-tag-filters pb-3"
                        [class.d-none]="availableLegalEntities.length <= 1"
                    >
                        <h4 class="mb-2">Filter by legal entity</h4>
                        <sb-badges
                            size="sm"
                            allowActive="multiple"
                            variant="primary"
                            wrap="true"
                            [badges]="availableLegalEntities"
                            (badgesChange)="filterLegalEntities($event)"
                        ></sb-badges>
                    </div>
                </ng-container>-->
                <!-- only show filter if more than one option exists -->
                <ng-container *ngIf="availableIssuers$ | async as availableIssuers">
                    <div
                        class="col-12 sb-tag-filters pb-3"
                        [class.d-none]="availableIssuers.length <= 1"
                    >
                        <h4 class="mb-2">Filter by issuer</h4>
                        <sb-badges
                            size="sm"
                            allowActive="multiple-not-empty"
                            variant="primary"
                            [wrap]="true"
                            [badges]="availableIssuers"
                            (badgesChange)="filterIssuers($event)"
                        ></sb-badges>
                    </div>
                </ng-container>
                <!-- only show filter if more than one option exists -->
                <ng-container
                    *ngIf="availableInstrumentTypes$ | async as availableInstrumentTypes"
                >
                    <div
                        class="col-12 sb-tag-filters pb-3"
                        [class.d-none]="availableInstrumentTypes.length <= 1"
                    >
                        <h4 class="mb-2">Filter by instrument type</h4>
                        <sb-badges
                            size="sm"
                            allowActive="multiple-not-empty"
                            variant="primary"
                            [wrap]="true"
                            [badges]="availableInstrumentTypes"
                            (badgesChange)="filterInstrumentTypes($event)"
                        ></sb-badges>
                    </div>
                </ng-container>
                <div class="col-12 sb-tag-filters pb-3">
                    <h4 class="mb-2">Show cash transfers (BETA)</h4>
                    <sb-slide-toggle
                        @fadeInOut
                        [formControl]="showEventsCtrl"
                        class="d-block pe-3"
                    ></sb-slide-toggle>
                </div>
            </div>
        </main>
        <footer
            class="sb-modal-grid-footer row gy-3 align-items-center text-center text-sm-right"
        >
            <div class="col-12">
                <button type="button" class="btn secondary" (click)="toggleShowOptions()">
                    Hide settings
                </button>
                <!--<button
                    type="button"
                    class="btn primary"
                    (click)="saveSettings()"
                    [disabled]="filterForm.pristine"
                >
                    Save and close
                </button>-->
            </div>
        </footer>
    </section>
</div>
<div
    [class.opacity-0]="(viewportSize$ | async) === 'xs'"
    class="backdrop"
    (click)="toggleShowOptions()"
    *ngIf="showOptions"
    [@fadeInOut]
></div>
